import { getStatusLabel } from './AuctionSharedUtils';

const AuctionHeroHeader = ({ auction = {}, lastUpdatedAt, pollIntervalMs, liveStreamingUrl, dashboard = false }) => dashboard ? (
  <section className="pav-hero" aria-label="Auction summary">
    <div><div className="pav-eyebrow">Public Auction View</div><h1>{auction.name || 'Auction'}</h1>
      <div className="pav-meta"><span className={`pav-badge ${auction.status === 'completed' ? 'pav-badge--success' : 'pav-badge--neutral'}`}>{getStatusLabel(auction.status)}</span><span className="pav-badge pav-badge--public">Public View</span>{lastUpdatedAt ? <span>Last updated {lastUpdatedAt.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span> : null}</div>
    </div>
    <div className="pav-stream"><div className="pav-stream-panel">{liveStreamingUrl ? <a href={liveStreamingUrl} target="_blank" rel="noopener noreferrer" className="pav-watch">Watch Live Streaming</a> : <><strong>Live Stream Not Available</strong><span>The live stream is not available for this auction.</span></>}</div><div className="pav-refresh"><span aria-hidden="true" />Auto refresh every {pollIntervalMs / 1000}s</div></div>
  </section>
) : (
  <div className="rounded-4 shadow-sm border overflow-hidden mb-4" style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 55%, #334155 100%)' }}>
    <div className="p-4 p-md-5 text-white">
      <div className="d-flex flex-column flex-lg-row justify-content-between align-items-start gap-4">
        <div className="flex-grow-1">
          <div className="small text-uppercase fw-semibold mb-2" style={{ letterSpacing: '0.08em', opacity: 0.85 }}>Public Auction View</div>
          <h1 className="h2 mb-2">{auction.name || 'Auction'}</h1>
          <div className="d-flex flex-wrap gap-2 align-items-center">
            <span className="badge rounded-pill bg-light text-dark text-capitalize px-3 py-2">{getStatusLabel(auction.status)}</span>
            <div className="badge rounded-pill bg-primary-subtle text-primary border border-primary-subtle px-3 py-2 text-capitalize">Public View</div>
            {lastUpdatedAt ? <span className="small" style={{ opacity: 0.8 }}>Last updated {lastUpdatedAt.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span> : null}
          </div>
        </div>
        <div className="w-100 w-lg-auto" style={{ maxWidth: 320 }}>
          <div className="d-grid gap-2">
            {liveStreamingUrl ? (
              <a href={liveStreamingUrl} target="_blank" rel="noopener noreferrer" className="btn fw-semibold rounded-pill px-4 py-2 text-white shadow-sm" style={{ background: 'linear-gradient(135deg, #ff4d4f, #dc3545)', border: 'none', minHeight: 44 }}>
                Watch Live Streaming
              </a>
            ) : (
              <button type="button" className="btn btn-outline-light fw-semibold rounded-pill px-4 py-2" disabled style={{ minHeight: 44 }}>
                Live Stream Not Available
              </button>
            )}
            <div className="d-inline-flex align-items-center justify-content-center gap-2 px-3 py-2 rounded-pill bg-white text-dark">
              <span className="rounded-circle" style={{ width: 8, height: 8, background: '#22c55e', display: 'inline-block' }} />
              <span className="small fw-semibold">Auto refresh every {pollIntervalMs / 1000}s</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default AuctionHeroHeader;
